import { makeVar } from '@apollo/client';

export const contentTypeNameVar = makeVar('');

export const metadataModalOpenVar = makeVar({ open: false });
